import { Timestamp } from "firebase/firestore";
import { createSchedulingCore } from "./schedulingCore";
export const {
  isPointInPolygon,
  doesLineExitPolygon,
  findAreas,
  getFutureAvailability,
  getCurrentArea,
  buildCoverageAreasFromPublicTimeline,
  getEmployeeCoverageAreas,
  getCoverageWindowsForPoint,
  shouldIncludeHelperInMemberList,
  getEmployeeStatus,
  getFutureAvailabilityForCoverageWindows,
  filterAvailabilityWindowsByCoverage,
  isRangeWithinCoverageWindows,
  distanceBetweenGeohashes,
  isWindowWithinDrivingRadius,
  calculateVisits,
  subtractWindowsFromVisits,
  padVisits,
  computeAvailabilityData
} = createSchedulingCore({ Timestamp });
